import React,{Component} from 'react';

import { Button } from 'react-bootstrap';

import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';

import NotificationTypes from '../../../../data/NotificationsTypes';



class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateFrom: '',
            dateTo: '',
            keyword: '',
            type: null
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleFieldChange(event) {
        const {target} = event;
        const {value,name} = target;

        this.setState({
            [name]: value
        });
    }

    handleButtonClick() {
        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <SelectWrap
                    values={NotificationTypes}
                    label="Type:"
                    name="type"
                    onChange={this.handleFieldChange}
                    value={this.state.type}
                />
                <FieldGroup
                    name="keyword"
                    label="Keyword:"
                    onChange={this.handleFieldChange}
                    value={this.state.keyword}
                />
                <FieldGroup
                    type="date"
                    name="dateFrom"
                    label="Date From:"
                    onChange={this.handleFieldChange}
                    value={this.state.dateFrom}
                />
                <FieldGroup
                    type="date"
                    name="dateTo"
                    label="Date To:"
                    onChange={this.handleFieldChange}
                    value={this.state.dateTo}
                />
                <Button onClick={this.handleButtonClick} className="m-b-15">Apply</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/Sent/components/Filters/index.js